export default __webpack_public_path__ + "static/media/iconProfileCreate.ca8d6659.svg";